import { CHANNEL_TYPES } from '@/common/constants/channel';
const CHANNEL_UNIVERSAL_TYPES = {
  all: -999, // 全部频道
  audio: CHANNEL_TYPES.audio, // 语音频道权限
  text: CHANNEL_TYPES.text, // 文字频道
  notice: CHANNEL_TYPES.notice, // 公告频道
  post: CHANNEL_TYPES.post, // 帖子频道
}

export const PERMISSION_GROUP = [{
  key: 'RoomManage',
  name: '通用房间管理',
  // 查看频道、管理频道、管理成员权限、管理表情包、管理语音包、查看管理日志、管理房间、管理房间活动、添加好友/私聊
  groups: [1, 2, 4, 30, 31, 3, 5, 38, 41] 
}, {
  key: 'membership',
  name: '成员身份',
  // 创建邀请、修改昵称、管理昵称、将某人踢出房间、将某人加入房间黑名单、禁言某人
  groups: [6, 8, 9, 10, 12, 13]
}, {
  key: 'textChannel',
  name: '文字频道',
  // 发送消息、上传文件、@全体、@在线和所有权限组、添加表情回应、管理消息、创建开黑邀约、发布组队、发送图片
  groups: [14, 15, 16, 17, 18, 20, 35, 36, 37, 39]
}, {
  key: 'audioChannel',
  name: '语音频道',
  // 加入语音频道、语音频道内说话、屏幕共享、录制语音、播放语音包、播放伴奏、静音成员、移动成员、主持人模式
  groups: [22, 23, 24, 34, 40, 32, 33, 26, 27, 42]
}, {
  key: 'advancedPermission',
  name: '高级权限',
  // 管理员
  groups: [0]
}]

export const PERMISSION_CONFIGS = [
  { //0
    name: '管理员',
    desc: '拥有除删除服务器之外的所有权限。',
    type: '',
    key: 'ManageServer',
    index: 0,
  },
  { //1
    name: '查看频道',
    desc: '允许成员查看频道（私密频道除外）。',
    type: '',
    key: 'ViewingChannel',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all, CHANNEL_UNIVERSAL_TYPES.post],
    index: 1,
  },
  { //2
    name: '管理频道',
    desc: '允许成员创建、编辑、删除频道。',
    type: '',
    key: 'EditChannel',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all, CHANNEL_UNIVERSAL_TYPES.post],
    index: 2,
  },
  { //3
    name: '查看审核日志',
    desc: '允许成员在此房间内查看用户在房间内的操作。',
    type: '',
    key: 'ViewAuditLog',
    index: 3,
  },
  { //4
    name: '管理成员权限',
    desc: '允许成员创建新的权限，可以编辑或删除比自身最高身份组限低的身份组。同时允许成员编辑自身可访问的频道的权限。',
    type: '',
    key: 'ManageRoles',
    index: 4,
  },
  { //5
    name: '管理房间',
    desc: '允许成员编辑房间名称，查看所有邀请。',
    type: '',
    key: 'RoomManager',
    index: 5,
  },
  { //6
    name: '创建邀请',
    desc: '允许成员邀请新人加入服务器。',
    type: '',
    key: 'CreateInvitation',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all],
    index: 6
  },
  { //7
    name: '管理邀请',
    desc: '',
    type: '',
    key: 'ManageInvitation',
    hidden: 1,
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all],
    index: 7
  },
  { //8
    name: '修改昵称',
    desc: '允许用户修改自己在房间的昵称。',
    type: '',
    key: 'ModifyNickname',
    index: 8,
  },
  { //9
    name: '管理昵称',
    desc: '允许用户修改别人在房间的昵称。',
    type: '',
    key: 'ManageNickname',
    index: 9,
  },
  { //10
    name: '将某人踢出房间',
    desc: '允许成员将其他成员从此房间踢出。被踢出的成员如果获得新的邀请，可再次加入此房间。',
    type: '',
    key: 'KickOutRoom',
    index: 10,
  },
  { //11
    name: '将某人踢出频道',
    desc: '',
    type: '',
    hidden: 1,
    key: 'KickOutChannel',
    index: 11,
  },
  { //12
    name: '将某人加入房间黑名单',
    desc: '允许用户将其他用户加入房间黑名单，被加入黑名单的用户将永远无法加入此房间，直至被移出黑名单。',
    type: '',
    key: 'CheckInRoomBlackList',
    index: 12,
  },
  { //13
    name: '禁言某人',
    desc: '允许用户对其他用户禁言，被禁言的用户无法在文字频道或语音频道中发言。',
    type: '',
    key: 'ProhibitedMemberTemporarily',
    index: 13
  },
  { //14
    name: '发送消息',
    desc: '',
    type: '',
    key: 'SendIM',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all, CHANNEL_UNIVERSAL_TYPES.post],
    index: 14
  },
  { //15
    name: '上传文件',
    desc: '允许成员在频道内发送文件',
    type: '',
    key: 'UploadFile',
    // channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all],
    index: 15
  },
  { //16
    name: '@全体、@在线和所有权限组',
    desc: '允许成员@全体成员或@在线成员，或@不同权限组的成员。',
    type: '',
    key: 'ATGroup',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all],
    index: 16
  },
  { //17
    name: '添加表情回应',
    desc: '',
    type: '',
    key: 'AddReaction',
    // channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all],
    index: 17
  },
  { //18
    name: '管理消息',
    desc: '允许成员删除其他成员发出的消息或设置精华消息。',
    type: '',
    key: 'ManageMessage',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all],
    index: 18
  },
  { //19
    name: '接收离线消息',
    desc: '允许成员接收离线时房间内的消息。如果关闭此权限，成员只能接收在线时房间内的消息。',
    type: '',
    key: 'ReadHistoryMessage',
    hidden: 1,
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all],
    index: 19
  },
  { //20
    name: '创建开黑邀约',
    desc: '',
    type: '',
    key: 'CreatePromise',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all],
    index: 20,
  },
  { //21
    name: '管理邀约',
    desc: '',
    type: '',
    key: 'ManagePromise',
    hidden: 1,
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all],
    index: 21
  },
  { //22
    name: '加入语音频道',
    desc: '允许成员加入语音频道，并听到其他成员发言。',
    type: '',
    key: 'JoinAudioChannel',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.audio],
    index: 22,
  },
  { //23
    name: '语音频道内说话',
    desc: '允许成员在语音频道内说话。如果该权限未开启，则成员默认处于已静音状态，直至具备"静音成员"权限者解除其静音状态为止。',
    type: '',
    key: 'Speak',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.audio],
    index: 23
  },
  { //24 TODO: 合并允许成员直接说话之后，需要在VoicePanel组件补充预览权限组是否允许直接说话的逻辑
    name: '允许直接讲话',
    desc: '允许成员通过直接讲话的方式在语音频道内发言。如果该权限未开启，则成员需要使用按键说话的方式进行发言。',
    type: '',
    key: 'SpeakFreely',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.audio],
    index: 24
  },
  { //25
    name: '频道静音',
    desc: '静音频道中所有用户。',
    type: '',
    key: 'MuteALL',
    hidden: 1,
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.audio],
    index: 25
  },
  { //26
    name: '静音成员',
    desc: '被静音的成员说话将无法被他人听到。',
    type: '',
    key: 'MuteUser',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.audio],
    index: 26
  },
  { //27
    name: '移动成员',
    desc: '允许成员断开连接或在语音频道之间移动其他成员。',
    type: '',
    key: 'MoveUser',
    index: 27
  },
  { //28
    name: '管理语句',
    desc: '',
    type: '',
    key: 'ManageExpression',
    hidden: 1,
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all],
    index: 28
  },
  { //29
    name: '管理邀约',
    desc: '',
    type: '',
    key: 'EditChannelPromise',
    hidden: 1,
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all],
    index: 29
  },
  { //30
    name: '管理表情',
    desc: '允许成员在此房间内上传、编辑、移除emoji和大表情。',
    type: '',
    key: 'ManageMeme',
    index: 30
  },
  { //31
    name: '管理语音包',
    desc: '允许成员在此房间内上传、编辑、移除语音包。',
    type: '',
    key: 'ManageSoundboard',
    index: 31,
  },
  { //32
    name: '播放语音包',
    desc: '允许成员在房间播放语音包。',
    type: '',
    key: 'PlayVoicePack',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.audio],
    index: 32,
  },
  { //33
    name: '播放伴奏',
    desc: '允许成员在房间共享伴奏。',
    type: '',
    key: 'PlayBGM',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.audio],
    index: 33,
  },
  { //34
    name: '屏幕共享',
    desc: '允许成员在此房间内进行屏幕共享。',
    type: '',
    key: 'ScreenShare',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.audio],
    index: 34,
  },
  { //35
    name: '发布组队',
    desc: '',
    type: '',
    key: 'TeamTool',
    index: 35,
  },
  { //36
    name: '使用机器人指令',
    desc: '允许成员使用机器人指令，包括直接输入指令或选择输入框中的“使用机器人指令”',
    type: '',
    key: 'UseBotCommand',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all],
    index: 36,
  },
  { //37
    name: '创建投票',
    desc: '',
    type: '',
    key: 'CreateVote',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all],
    index: 37,
  },
  { //38
    name: '管理房间活动',
    desc: '',
    type: '',
    key: 'ManageRoomAct',
    index: 38,
  },
  { //39
    name: '发送图片',
    desc: '允许成员在频道内发送图片',
    type: '',
    key: 'SendImage',
    index: 39,
  },
  { //40
    name: '录制语音',
    desc: '允许成员在房间内录音',
    type: '',
    key: 'AudioRecord',
    index: 40,
  },
  { //40
    name: '添加好友/私聊',
    desc: '允许用户在房间内与他人私聊或添加他人为好友',
    type: '',
    key: 'allowRoomRelation',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.all],
    index: 41,
  },
  {
    name: '主持人模式',
    desc: '允许成员开启或管理主持人模式，管理成员上下麦。允许成员在主持人模式下自由上下麦。',
    type: '',
    key: 'ManageHost',
    channelUniversal: [CHANNEL_UNIVERSAL_TYPES.audio],
    index: 42,
  },
].map(v => Object.freeze(v))


export const CHANNEL_PERMISSION_CONFIGS = PERMISSION_CONFIGS.filter(item => item.hasOwnProperty('channelUniversal'));

export const TEXT_CHANNEL_PERMISSION_CONFIGS = PERMISSION_CONFIGS.filter(item => item.channelUniversal?.includes(CHANNEL_UNIVERSAL_TYPES.all) || item.channelUniversal?.includes(CHANNEL_UNIVERSAL_TYPES.text));

export const AUDIO_CHANNEL_PERMISSION_CONFIGS = PERMISSION_CONFIGS.filter(item => item.channelUniversal?.includes(CHANNEL_UNIVERSAL_TYPES.audio));

export const POST_CHANNEL_PERMISSION_CONFIGS = PERMISSION_CONFIGS.filter(item => item.channelUniversal?.includes(CHANNEL_UNIVERSAL_TYPES.post));

export function GET_PERMISSION_NAME(key) {
  return PERMISSION_CONFIGS.find(v=> v.key === key)?.name
}

// 按照group排序输出configs
export function getAllOrderPermissions ()  {
  const list = []
  const configs = JSON.parse(JSON.stringify(PERMISSION_CONFIGS))
  PERMISSION_GROUP.forEach(group => {
    group.groups.forEach(key => {
      const item = configs.find(v => v.index === key)
      if (item && !item.hidden) {
        list.push(item)
      }
    })
  })
  return list
}